import css from 'styled-jsx/css';

export default css.global`img {
  width: 100%;
}

.hero-section {
  padding: 4rem 0 0;
}

.hero-section .product-logo {
  display: flex;
  align-items: center;
  margin-bottom: 42px;
}

.hero-section .product-logo img {
  width: 60px;
  margin-right: 1rem;
}

.hero-section .product-logo span {
  font-weight: 700;
  display: block;
}

.hero-section ._inner aside.text-cont {
  margin-bottom: 3rem;
}

.hero-section ._inner aside.text-cont .title {
  color: #2f2e7c;
  font-weight: bold;
  line-height: 1.3;
  padding-bottom: 2rem;
}

.hero-section ._inner aside.text-cont .sub-title {
  line-height: 1.5;
  color: #4e4d4d;
  font-size: 1.8rem;
  padding-bottom: 3rem;
}

.hero-section ._inner aside.image-cont {
  margin-top: 8rem;
  /* display: none; */
}

.automate-section {
  padding: 8rem 0;
}

.automate-section-title {
  color: #2f2e7c;
  text-align: center;
  font-weight: bold;
  line-height: 1.4;
  margin-bottom: 5rem;
}

.automate-section-sub-title {
  line-height: 1.5;
  font-size: 1.7rem;
  text-align: center;
}

.automate-section .content-cont {
  margin-top: 10rem;
}

.icon-box {
  line-height: 1.8;
  color: #4e4d4d;
  margin-bottom: 8rem;
  /* border-radius: 20px; */
  padding: 48px;
}

.automate-section .content-cont .icon-box:nth-child(1) {
  background-color: #fff5e1;
}

.automate-section .content-cont .icon-box:nth-child(2) {
  background-color: #F3FFF6;
}

.automate-section .content-cont .icon-box:nth-child(3) {
  background-color: #d6ecdc;
}

.icon-box img {
  width: 70px;
  height: 70px;
  margin-bottom: 16px;
}

.icon-box .title {
  font-weight: bold;
  color: #000000;
  font-size: 2rem;
}

.icon-box .desc {
  font-size: 16px;
}

.bottom-sect {
  padding: 15rem 0;
  text-align: center;
  background-color: #2f2e7c;
}

.bottom-sect .title {
  font-size: 3rem;
  font-weight: bold;
  color: #fff;
}

.bottom-sect .sub-title {
  color: #fff;
  font-size: 1.8rem;
  padding: 3rem 0;
}

.bottom-sect .cta {
  margin-top: 3rem;
  margin-bottom: 1rem;
}

.what-sect {
  margin: 7rem 0;
  background-color: #fafafa;
  padding: 8rem 0;
}

.what-sect .title {
  color: #2f2e7c;
  font-weight: bold;
  font-size: 3rem;
}

.what-sect .sub-title {
  font-size: 1.6rem;
  line-height: 1.7;
}

.bottom-sect .note {
  color: #b1272c;
}

.cta-cont a:first-child {
  margin-right: 1rem;
}

.details-image-sect {
  margin-bottom: 9rem;
  background-image: url("/static/img/ucg/bg-3.svg"),
    url("/static/img/ucg/bg-1.svg"), url("/static/img/ucg/bg-1.svg"),
    url("/static/img/ucg/bg-2.svg"), url("/static/img/ucg/bg-1.svg"),
    url("/static/img/ucg/bg-4.svg"), url("/static/img/ucg/bg-1.svg"),
    url("/static/img/ucg/bg-6.svg"), url("/static/img/ucg/bg-5.svg"),
    url("/static/img/ucg/bg-1.svg");

  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
    no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: top center, 90% 200px, 30% 18%, 90% 28%, 90% 44%, 45% 50%,
    42% 65%, 23% 70%, 90% 75%, 54% 94%;
  background-size: 100px, 50px, 30px, 100px, 30px, 100px, 30px, 100px, 100px,
    30px;
}

.details-image-sect_row {
  display: flex;
  flex-direction: column;
  margin-bottom: 10rem;
}

.details-image-sect_row .text-cont .title {
  color: #2f2e7c;
  font-weight: bold;
  font-size: 3rem;
}

.details-image-sect_row .text-cont .sub-title {
  font-size: 16px;
  line-height: 1.7;
}

.details-image-sect_row .text-cont {
  order: 2;
}

.details-image-sect_row .image-cont {
  margin-bottom: 2rem;
  order: 1;
}

@media (min-width: 768px) {
  .automate-section .content-cont {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5rem;
  }

  .icon-box {
    margin-bottom: 0;
  }

  .info-box-sect .list-container {
    margin: auto;
    grid-template-columns: repeat(2, 1fr);
  }

  .details-image-sect_row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .details-image-sect_row .text-cont {
    order: 2;
    width: 40%;
  }

  .details-image-sect_row .image-cont {
    margin-bottom: 0;
    width: 48%;
    order: 1;
  }

  .details-image-sect_row:nth-child(odd) .text-cont {
    order: 1;
  }

  .details-image-sect_row:nth-child(odd) .image-cont {
    order: 2;
  }
}

@media (min-width: 1023px) {
  .hero-section ._inner {
    display: grid;
    grid-template-columns: 5fr 5fr;
    padding: 4rem 0 12rem;
    align-items: flex-start;
    gap: 3rem;
  }

  .hero-section ._inner aside.text-cont {
    margin-bottom: 0;
  }

  .hero-section ._inner aside.image-cont {
    display: block;
    margin-top: 0;
    position: relative;
  }

  .hero-section ._inner aside.image-cont img {
    width: 700px;
    position: absolute;
    top: -5rem;
    left: -7rem;
  }

  .hero-section ._inner aside.text-cont .title {
    font-size: 4rem;
  }

  .hero-section .bottom-img-cont {
    width: 800px;
    margin: -100px auto 0;
  }

  .automate-section-title {
    width: 600px;
    font-size: 3.3rem;
    margin-inline: auto;
  }

  .automate-section-sub-title {
    width: 750px;
    font-size: 1.8rem;
    margin: auto;
  }

  .automate-section .content-cont {
    grid-template-columns: repeat(3, 1fr);
  }

  .bottom-sect .title {
    font-size: 3.5rem;
    width: 850px;
    margin: auto;
  }

  .bottom-sect .sub-title {
    width: 450px;
    margin-inline: auto;
  }

  .what-sect .title {
    font-size: 4.5rem;
    width: 30%;
  }

  .what-sect .sub-title {
    font-size: 2rem;
    width: 55%;
    margin-left: 2rem;
  }

  .what-sect-inner {
    display: flex;
    justify-content: center;
  }

  .details-image-sect {
    margin-top: 9rem;
  }

  .details-image-sect_row .text-cont .sub-title {
    font-size: 18px;
  }
}
`